import React from 'react';

/**
 * Acumen AI Circle Animation Component
 * Animated circular indicator for AI processing states
 */
function AcumenAICircle({ size = 'md', isProcessing = false, className = '' }) {
  const sizes = {
    xs: { wrapper: 'w-4 h-4', inner: 'w-2.5 h-2.5', text: 'text-[6px]' },
    sm: { wrapper: 'w-6 h-6', inner: 'w-4 h-4', text: 'text-xs' },
    md: { wrapper: 'w-10 h-10', inner: 'w-6 h-6', text: 'text-sm' },
    lg: { wrapper: 'w-14 h-14', inner: 'w-9 h-9', text: 'text-base' },
    xl: { wrapper: 'w-20 h-20', inner: 'w-14 h-14', text: 'text-lg' }
  };

  const s = sizes[size] || sizes.md;

  return (
    <div className={`relative ${s.wrapper} ${className}`}>
      {/* Outer rotating ring - always spins, faster when processing */}
      <div 
        className={`absolute inset-0 rounded-full border-2 border-transparent border-t-purple-400 border-r-blue-400 animate-spin`}
        style={{ animationDuration: isProcessing ? '1s' : '3s' }}
      ></div>
      
      {/* Middle pulsing ring */}
      <div 
        className={`absolute inset-1 rounded-full ${
          isProcessing 
            ? 'bg-gradient-to-br from-purple-500/30 to-blue-500/30 animate-pulse' 
            : 'bg-gradient-to-br from-purple-500/20 to-blue-500/20'
        }`}
      ></div>
      
      {/* Inner circle with AI text */}
      <div 
        className={`absolute inset-0 flex items-center justify-center`}
      >
        <div 
          className={`${s.inner} rounded-full bg-gradient-to-br from-purple-600 to-blue-600 flex items-center justify-center shadow-lg ${
            isProcessing ? 'animate-pulse' : ''
          }`}
        >
          <span className={`${s.text} font-bold text-white`}>AI</span>
        </div>
      </div>

      {/* Processing particles */}
      {isProcessing && (
        <>
          <div className="absolute inset-0 rounded-full">
            <div className="absolute top-0 left-1/2 w-1 h-1 bg-purple-400 rounded-full animate-ping" style={{ animationDuration: '1s' }}></div>
            <div className="absolute bottom-0 left-1/2 w-1 h-1 bg-blue-400 rounded-full animate-ping" style={{ animationDuration: '1.2s' }}></div>
            <div className="absolute left-0 top-1/2 w-1 h-1 bg-purple-400 rounded-full animate-ping" style={{ animationDuration: '0.8s' }}></div>
            <div className="absolute right-0 top-1/2 w-1 h-1 bg-blue-400 rounded-full animate-ping" style={{ animationDuration: '1.4s' }}></div>
          </div>
        </>
      )}
    </div>
  );
}

export default AcumenAICircle;
